<suggestion-drawer-heading [heading]="heading"></suggestion-drawer-heading>
<ng-content></ng-content>
